import { Suspense, lazy } from 'react';

import { PageLoader } from '@/shared/ui';

const DashboardAsync = lazy(() => import('./ui/Dashboard'));

export const Dashboard = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <DashboardAsync />
    </Suspense>
  );
};
